<div class="fade-in">
  <div class="content-section">
    <div class="section-header">
      <h2>Artist Management</h2>
      <button class="primary-btn" (click)="openAddModal()">+ Add Artist</button>
    </div>

    <!-- Modal Form for Add/Edit -->
    <div class="modal-overlay" *ngIf="isModalOpen">
      <div class="modal-content fade-in" [class.saving-mode]="isSaving">
      
      <div class="am-modal-head">
        <h3 class="modal-title am-modal-title">
          {{ editingId ? 'Edit Artist' : 'Add New Artist' }}
        </h3>
        <div class="am-active-toggle">
          <input type="checkbox" [(ngModel)]="newArtist.isActive" [disabled]="isSaving" id="isActive" class="artist-checkbox am-checkbox">
          <label for="isActive" class="am-active-label">Active</label>
        </div>
      </div>
      
      <div class="form-grid">
        <div class="form-group">
          <label>Name *</label>
          <input [(ngModel)]="newArtist.name" [disabled]="isSaving" placeholder="Artist Name" class="form-input">
        </div>
        <div class="form-group">
          <label>Commission Amount ($)</label>
          <input type="number" step="0.01" [(ngModel)]="newArtist.commission_amount" [disabled]="isSaving" placeholder="0.00" class="form-input">
        </div>
        <div class="form-group">
          <label>Email *</label>
          <input type="email" [(ngModel)]="newArtist.email" [disabled]="isSaving" placeholder="artist@example.com" class="form-input">
        </div>
        <div class="form-group">
          <label>Phone</label>
          <input [(ngModel)]="newArtist.phone" [disabled]="isSaving" placeholder="(555) 123-4567" class="form-input">
        </div>
        <div class="form-group full-width">
          <label>Address</label>
          <input [(ngModel)]="newArtist.address" [disabled]="isSaving" placeholder="Address" class="form-input">
        </div>
        <div class="form-group full-width">
          <label>Bio</label>
          <textarea [(ngModel)]="newArtist.bio" [disabled]="isSaving" placeholder="Artist biography..." class="form-input am-bio"></textarea>
        </div>
      </div>

      <!-- Documents Section -->
      <div class="modal-section am-section-tight" *ngIf="editingId">
        <h4 class="section-title am-docs-title">Documents</h4>
        
        <!-- W-9 Document -->
        <div class="doc-group">
          <h5>W-9 <span class="doc-check" *ngIf="getFilesByType('W-9').length > 0">✓</span></h5>
          <div class="file-list am-file-list" *ngIf="getFilesByType('W-9').length > 0">
            <div class="file-item" *ngFor="let file of getFilesByType('W-9')">
              <a [href]="file.url" target="_blank" class="file-link" [title]="file.name">{{ file.name }}</a>
              <button class="delete-file-btn" (click)="deleteSpecificFile(file)" title="Delete" [disabled]="deletingFile === file || uploadingFile">
                <span *ngIf="deletingFile === file">...</span>
                <span *ngIf="deletingFile !== file">&times;</span>
              </button>
            </div>
          </div>
          <input type="file" class="file-input-sm" (change)="uploadSpecificFile($event, 'W-9')" [disabled]="uploadingFile">
        </div>

        <!-- Contract -->
        <div class="doc-group">
          <h5>Contract <span class="doc-check" *ngIf="getFilesByType('Contract').length > 0">✓</span></h5>
          <div class="file-list am-file-list" *ngIf="getFilesByType('Contract').length > 0">
            <div class="file-item" *ngFor="let file of getFilesByType('Contract')">
              <a [href]="file.url" target="_blank" class="file-link" [title]="file.name">{{ file.name }}</a>
              <button class="delete-file-btn" (click)="deleteSpecificFile(file)" title="Delete" [disabled]="deletingFile === file || uploadingFile">
                <span *ngIf="deletingFile === file">...</span>
                <span *ngIf="deletingFile !== file">&times;</span>
              </button>
            </div>
          </div>
          <input type="file" class="file-input-sm" (change)="uploadSpecificFile($event, 'Contract')" [disabled]="uploadingFile">
        </div>

        <!-- Other Docs -->
        <div class="doc-group">
          <h5>Other Docs <span class="doc-check" *ngIf="getFilesByType('Other').length > 0">✓</span></h5>
          <div class="file-list am-file-list" *ngIf="getFilesByType('Other').length > 0">
            <div class="file-item" *ngFor="let file of getFilesByType('Other')">
              <a [href]="file.url" target="_blank" class="file-link" [title]="file.name">{{ file.name }}</a>
              <button class="delete-file-btn" (click)="deleteSpecificFile(file)" title="Delete" [disabled]="deletingFile === file || uploadingFile">
                <span *ngIf="deletingFile === file">...</span>
                <span *ngIf="deletingFile !== file">&times;</span>
              </button>
            </div>
          </div>
          <input type="file" class="file-input-sm" multiple (change)="uploadSpecificFile($event, 'Other')" [disabled]="uploadingFile">
        </div>

        <div *ngIf="uploadingFile" class="uploading-container">
          <div class="uploading-header">
            <span>Uploading...</span>
            <span>{{ uploadProgress }}%</span>
          </div>
          <div class="progress-bar-container">
            <div class="progress-bar-fill" [style.width.%]="uploadProgress"></div>
          </div>
        </div>

        <div *ngIf="uploadedFileUrl === 'done'" class="upload-success-msg">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
          Successfully uploaded!
        </div>
      </div>
      <div class="modal-section am-section-tight" *ngIf="!editingId">
         <p class="am-muted-note">Save the artist first to attach documents.</p>
      </div>

      <!-- KAN-149 AC-4: frames owned by this artist (changes save immediately) -->
      <section class="modal-section frames-section" aria-labelledby="assigned-frames-title">
        <div class="frames-head">
          <h4 id="assigned-frames-title" class="frames-title">Assigned frames <span *ngIf="editingId && framesLoaded">({{ assignedFrames.length }})</span></h4>
          <button type="button" class="secondary-btn touch-btn" *ngIf="editingId" (click)="openPicker()"
            [disabled]="!canAddFrames || framesLoading || !framesLoaded">+ Add frames</button>
        </div>
        <p class="frames-note" *ngIf="!editingId">Save the artist first to assign frames.</p>
        <ng-container *ngIf="editingId">
          <p class="frames-note">Frame changes save immediately; they do not wait for "Update Artist".</p>
          <p class="frames-note" *ngIf="!canAddFrames">This artist is inactive, so no frames can be added. Existing frames can still be removed.</p>
          <p class="frames-note" role="status" *ngIf="framesLoading">Loading frames…</p>
          <p class="frames-error" role="alert" *ngIf="framesError">{{ framesError }}</p>
          <p class="frames-note" *ngIf="framesLoaded && !framesLoading && assignedFrames.length === 0">No frames assigned yet.</p>

          <ul class="assigned-frame-list" *ngIf="assignedFrames.length > 0">
            <li class="assigned-frame-row" *ngFor="let f of assignedFrames">
              <button type="button" class="frame-thumb" *ngIf="thumbUrls.get(f.frameId) as url; else noImg" (click)="openFramePreview(f)"
                [attr.aria-label]="'View frame ' + f.frameId + ' full size'" title="Click to view full size">
                <img [src]="url" [alt]="f.frameId">
              </button>
              <ng-template #noImg>
                <span class="frame-thumb no-thumb" tabindex="0" [title]="noImageReason(f.frameId)" [attr.aria-label]="'No image: ' + noImageReason(f.frameId)">
                  <span class="no-img">No Img</span>
                </span>
              </ng-template>
              <div class="frame-meta">
                <span class="frame-id">{{ f.frameId }}</span>
                <span class="frame-group">{{ f.copies[0].groupName }}</span>
                <span class="scope-badges">
                  <span class="scope-badge" *ngFor="let c of f.copies">{{ scopeLabel(c) }}</span>
                </span>
                <span class="frames-error" role="alert" *ngIf="rowError.get(f.frameId)">{{ rowError.get(f.frameId) }}</span>
              </div>
              <div class="frame-actions">
                <ng-container *ngIf="removeConfirmFrameId !== f.frameId; else confirmRemoveTpl">
                  <button type="button" class="link-danger touch-btn" (click)="askRemove(f.frameId)" [disabled]="rowBusy.has(f.frameId)">
                    {{ rowBusy.has(f.frameId) ? 'Removing…' : 'Remove' }}
                  </button>
                </ng-container>
                <ng-template #confirmRemoveTpl>
                  <span class="confirm-text">Back to {{ ownershipText.unassigned }}?</span>
                  <button type="button" class="link-danger touch-btn" (click)="confirmRemove(f)">Remove</button>
                  <button type="button" class="secondary-btn touch-btn" (click)="removeConfirmFrameId = null">Keep</button>
                </ng-template>
              </div>
            </li>
          </ul>
        </ng-container>
      </section>

      <div *ngIf="generalErrorMessage" class="error-message mb">
        {{ generalErrorMessage }}
      </div>

      <div class="modal-actions">
        <button class="secondary-btn" (click)="cancelEdit()" [disabled]="isSaving">Cancel</button>
        <button class="primary-btn" (click)="saveArtist()" [disabled]="isSaving">
          {{ isSaving ? 'Saving...' : (editingId ? 'Update Artist' : 'Add Artist') }}
        </button>
      </div>
    </div>
    </div>

    <!-- KAN-149 AC-5: all-frames picker (layered over the artist modal) -->
    <div class="modal-overlay picker-overlay" *ngIf="isPickerOpen">
      <div class="modal-content picker-modal" role="dialog" aria-modal="true" aria-labelledby="picker-title">
        <div class="picker-header">
          <h3 id="picker-title" class="modal-title">Add frames to {{ newArtist.name }}</h3>
          <button type="button" class="close-icon-btn" (click)="closePicker()" [disabled]="pickerSaving" aria-label="Close">×</button>
        </div>

        <div class="picker-filters">
          <label class="visually-hidden" for="picker-search">Search frames</label>
          <input id="picker-search" class="form-input" type="search" placeholder="Search by frame ID, theme, group or device"
            [(ngModel)]="pickerSearch" (ngModelChange)="recomputePicker()">
          <div class="picker-filter-row">
            <label class="picker-filter">
              <span>Show</span>
              <select class="form-select" [(ngModel)]="pickerShowAll" (ngModelChange)="recomputePicker()">
                <option [ngValue]="false">Unassigned only</option>
                <option [ngValue]="true">Show all frames</option>
              </select>
            </label>
            <label class="picker-filter">
              <span>Scope</span>
              <select class="form-select" [(ngModel)]="pickerScope" (ngModelChange)="recomputePicker()">
                <option value="all">All</option>
                <option value="global">Global</option>
                <option value="device">Device</option>
              </select>
            </label>
          </div>
          <p class="frames-note" role="status">{{ pickerRows.length }} frame{{ pickerRows.length === 1 ? '' : 's' }}</p>
        </div>

        <div class="picker-body">
          <p class="frames-note" *ngIf="pickerRows.length === 0">
            {{ pickerShowAll ? 'No frames match.' : 'No unassigned frames match. Choose "Show all frames" to see frames owned by other artists.' }}
          </p>
          <ul class="picker-list" *ngIf="pickerRows.length > 0">
            <li class="picker-row" *ngFor="let r of pagedPickerRows">
              <label class="picker-check">
                <input type="checkbox" [checked]="pickerSelected.has(r.entry.frameId)" (change)="togglePick(r.entry.frameId)" [disabled]="pickerSaving">
                <span class="visually-hidden">Select {{ r.entry.frameId }}</span>
              </label>
              <button type="button" class="frame-thumb" *ngIf="thumbUrls.get(r.entry.frameId) as url; else pickNoImg" (click)="openFramePreview(r.entry)"
                [attr.aria-label]="'View frame ' + r.entry.frameId + ' full size'" title="Click to view full size">
                <img [src]="url" [alt]="r.entry.frameId">
              </button>
              <ng-template #pickNoImg>
                <span class="frame-thumb no-thumb" tabindex="0" [title]="noImageReason(r.entry.frameId)" [attr.aria-label]="'No image: ' + noImageReason(r.entry.frameId)">
                  <span class="no-img">No Img</span>
                </span>
              </ng-template>
              <div class="frame-meta">
                <span class="frame-id">{{ r.entry.frameId }}</span>
                <span class="frame-group">{{ r.entry.copies[0].groupName }}</span>
                <span class="scope-badges">
                  <span class="scope-badge" *ngFor="let c of r.entry.copies">{{ scopeLabel(c) }}</span>
                </span>
                <span class="frames-error" role="alert" *ngIf="rowError.get(r.entry.frameId)">{{ rowError.get(r.entry.frameId) }}</span>
              </div>
              <span class="owner-badge" [class.owner-unassigned]="r.owner.kind === 'unassigned'" [class.owner-deleted]="r.owner.kind === 'ownerDeleted'">
                <ng-container [ngSwitch]="r.owner.kind">
                  <ng-container *ngSwitchCase="'unassigned'">{{ ownershipText.unassigned }}</ng-container>
                  <ng-container *ngSwitchCase="'ownerDeleted'">{{ ownershipText.ownerDeleted }}</ng-container>
                  <ng-container *ngSwitchDefault>Owner: {{ r.owner.artistName }}{{ r.owner.inactive ? ' (inactive)' : '' }}</ng-container>
                </ng-container>
              </span>
            </li>
          </ul>
          <div class="picker-pager" *ngIf="pickerPageCount > 1">
            <button type="button" class="secondary-btn touch-btn" (click)="goPickerPage(-1)" [disabled]="pickerPage === 0">Previous</button>
            <span>Page {{ pickerPage + 1 }} of {{ pickerPageCount }}</span>
            <button type="button" class="secondary-btn touch-btn" (click)="goPickerPage(1)" [disabled]="pickerPage >= pickerPageCount - 1">Next</button>
          </div>
        </div>

        <div class="picker-confirm" role="alertdialog" aria-labelledby="take-title" *ngIf="pickerConfirming">
          <p id="take-title" class="confirm-title">These frames belong to other artists and will move to {{ newArtist.name }}:</p>
          <ul class="take-list">
            <li *ngFor="let r of rowsToTake">{{ r.entry.frameId }}: {{ r.owner.artistName }} → {{ newArtist.name }}</li>
          </ul>
          <p class="frames-note">A frame belongs to one artist only. {{ ownershipText.allCopies }}</p>
        </div>
        <p class="frames-error" role="alert" *ngIf="pickerError">{{ pickerError }}</p>

        <div class="picker-footer">
          <button type="button" class="secondary-btn touch-btn" (click)="pickerConfirming ? (pickerConfirming = false) : closePicker()" [disabled]="pickerSaving">
            {{ pickerConfirming ? 'Back' : 'Cancel' }}
          </button>
          <button type="button" class="primary-btn touch-btn" (click)="addSelectedFrames()" [disabled]="pickerSaving || pickerSelected.size === 0">
            {{ pickerSaving ? 'Saving…' : (pickerConfirming ? 'Move and assign' : 'Add ' + pickerSelected.size + ' frame' + (pickerSelected.size === 1 ? '' : 's')) }}
          </button>
        </div>
      </div>
    </div>

    <!-- Full-size frame image (shared popup from Photobooth Management, KAN-149 AC-6) -->
    <app-frame-image-preview [url]="previewUrl" alt="Frame full size" (closed)="previewUrl = null"></app-frame-image-preview>

    <!-- Artists Grid/Table -->
    <div style="overflow-x: auto;">
      <table class="ledger-table" *ngIf="artists && artists.length > 0; else noArtists">
        <thead>
          <tr>
            <th class="sortable" (click)="onSort('name')">
              Name
              <span class="sort-icon" *ngIf="sortColumn === 'name'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="sortable" (click)="onSort('email')">
              Email
              <span class="sort-icon" *ngIf="sortColumn === 'email'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="sortable" (click)="onSort('address')">
              Address
              <span class="sort-icon" *ngIf="sortColumn === 'address'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="sortable" (click)="onSort('commission_amount')">
              Commission Amount
              <span class="sort-icon" *ngIf="sortColumn === 'commission_amount'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="sortable" (click)="onSort('isActive')">
              Status
              <span class="sort-icon" *ngIf="sortColumn === 'isActive'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="text-center">Docs</th>
            <th class="col-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let artist of artists">
            <td class="artist-name">{{ artist.name }}</td>
            <td>{{ artist.email }}</td>
            <td>{{ artist.address }}</td>
            <td>{{ artist.commission_amount != null ? (artist.commission_amount | currency) : '' }}</td>
            <td>
              <span class="status-badge" [class.active]="artist.isActive" [class.inactive]="!artist.isActive">
                {{ artist.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="text-center">
              <span *ngIf="artist.files?.length > 0" class="doc-icon" [title]="getDocsTooltip(artist)">
                📑
              </span>
            </td>
            <td class="text-center">
              <button class="icon-action-btn mr" (click)="editArtist(artist)" title="Edit">✏️</button>
              <button class="icon-action-btn" (click)="deleteArtist(artist.id)" title="Delete">🗑️</button>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #noArtists>
        <div class="empty-state">
          <p>No artists found. <a href="javascript:void(0)" (click)="openAddModal()" class="empty-add-link">Add one now</a></p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
